module.exports = __webpack_public_path__ + "img/category.12bedb89.svg";